/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Model_HighInputs */

const en_landing_studio_model_high = /** @type {(inputs: Landing_Studio_Model_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 High`)
};

const zh_landing_studio_model_high = /** @type {(inputs: Landing_Studio_Model_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 High`)
};

/**
* | output |
* | --- |
* | "Ideogram 4.5 High" |
*
* @param {Landing_Studio_Model_HighInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_model_high = /** @type {((inputs?: Landing_Studio_Model_HighInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Model_HighInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_model_high(inputs)
	return zh_landing_studio_model_high(inputs)
});
export { landing_studio_model_high as "landing.studio.model_high" }